import { browserName, isMobile, osName } from 'react-device-detect';
import {
  EPublisherWebhookEventType,
  ELoginMethods,
  ELoginEvents,
  ELocalStorageKeys,
  ESessionStorageKeys,
  ELoginEventsV2,
  EPublisherWebhookEventTypeV2,
} from '../constants/enums';
import useApi from './useApi';
import useCustomEvents from './useCustomEvents';
import { appStateService } from 'state/app.state.service';
import { webStorageUtil } from 'state/webStorage.state.service';

export default function useLoginEvents() {
  const customEvents = useCustomEvents();
  const API = useApi({
    platform: isMobile ? osName : browserName,
  });

  const sendPublisherWebhookLoginEvent = async ({ //TODO: remove after events v1 deprecation
    eventName,
    method,
    options,
  }: {
    eventName: ELoginEvents;
    method?: ELoginMethods;
    options?: Record<string, any>;
  }) => {
    try {
      const utmParams = appStateService.utms.get() || {};
      API.sendPublisherWebhookEvent.mutate({
        eventType: EPublisherWebhookEventType.LOGIN,
        data: {
          eventName,
          method,
          source: webStorageUtil.get(ESessionStorageKeys.SOURCE) || 'browser app',
          utmSource: utmParams.utm_source,
          utmCampaign: utmParams.utm_campaign,
          utmMedium: utmParams.utm_medium,
          utmContent: utmParams.utm_content,
          utmTerm: utmParams.utm_term,
          ...options,
          ...customEvents.getEventsSharedProps(),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const sendPublisherWebhookLoginEventV2 = async ({
    eventName,
    eventType,
    method,
    options,
  }: {
    eventName: ELoginEventsV2;
    eventType: EPublisherWebhookEventTypeV2.POST_LOGIN | EPublisherWebhookEventTypeV2.PRE_LOGIN;
    method?: ELoginMethods;
    options?: Record<string, any>;
  }) => {
    try {
      const utmParams = appStateService.utms.get() || {};
      API.sendPublisherWebhookEventV2.mutate({
        eventType,
        data: {
          eventName,
          method,
          source: webStorageUtil.get(ESessionStorageKeys.SOURCE) || 'browser app',
          utmSource: utmParams.utm_source,
          utmCampaign: utmParams.utm_campaign,
          utmMedium: utmParams.utm_medium,
          utmContent: utmParams.utm_content,
          utmTerm: utmParams.utm_term,
          ...options,
          ...customEvents.getEventsSharedProps(),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const recordLoginStartTime = (): void => {
    webStorageUtil.set(ELocalStorageKeys.LOGIN_START_TIME, new Date().getTime());
  };

  const calcLoginDuration = (): number => {
    const loginEndTime = new Date().getTime();
    const loginStartTime = webStorageUtil.get(ELocalStorageKeys.LOGIN_START_TIME);
    return Math.round((loginEndTime - loginStartTime) / 1000);
  };

  return {
    sendPublisherWebhookLoginEvent,
    sendPublisherWebhookLoginEventV2,
    recordLoginStartTime,
    calcLoginDuration,
  };
}
